import cartReducer from "./cartReducer";
import wishlistReducer from "./wishlistReducer";
import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const persist1Config = {
  key: "root1",
  version: 1,
  storage,
};

const persistedReducer = persistReducer(persistConfig, cartReducer);
const persistedReducer1 = persistReducer(persist1Config, wishlistReducer);

export const store = configureStore({
  reducer: {
    cart: persistedReducer,
    wishlist: persistedReducer1,
  },
  devTools: process.env.NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor = persistStore(store);
